module.exports = ":host {\n  display: block;\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/examples/expand-on-click/expand-on-click.component.css
// module id = ./src/app/examples/expand-on-click/expand-on-click.component.css
// module chunks = main